import { useQuery } from 'data-fetching-client';
import { USER_PREFERENCES_QUERY } from '../queries/userPreferencesQuery';
export const useUserPreferences = () => {
  const {
    data,
    loading,
    error
  } = useQuery(USER_PREFERENCES_QUERY);
  return {
    userPreferences: data === null || data === void 0 ? void 0 : data.userPreferences,
    loading,
    error
  };
};